import { TimeRange } from '@nf/types/common';

type SportNewTagMap = {
	[key: number]: TimeRange;
};

export const sportNewTagMap: SportNewTagMap = {
	116: { to: 1771171199000 }, // 2026/02/15 23:59:59 GMT+8
	134: { to: 1771171199000 }, // 2026/02/15 23:59:59 GMT+8
	108: { to: 1780718399000 }, // 2026/06/05 23:59:59 GMT+8
	109: { to: 1780718399000 }, // 2026/06/05 23:59:59 GMT+8
	180: { to: 1780718399000 }, // 2026/06/05 23:59:59 GMT+8
	9994: { to: 1751126399000 }, // 2025/06/28 23:59:59 GMT+8
	112: { to: 1782662399000 }, // 2026/06/28 23:59:59 GMT+8
};

type SportPickTagMap = {
	[key: string]: TimeRange;
};

export const featureNewTagMap: SportPickTagMap = {
	betBuilderPlusBasketball: { to: 1771689599000 }, // 2026/02/21 23:59:59 GMT+8
	betBuilderPlusSoccer: { to: 1774367999000 }, // 2026/03/24 23:59:59 GMT+8
};

export const sportPickTagMap: SportPickTagMap = {
	sbr: { to: 1766678399000 }, // 2025/12/25 23:59:59 GMT+8
};